import React from 'react'

import { twm } from '../../lib/utils/twm'

export interface PillProps {
  count: number
  children: string
  className?: string
}

export const Pill: React.FC<PillProps> = ({ children, count, className }) => {
  return (
    <div
      className={twm(
        'flex w-fit flex-row items-center gap-6 rounded-full bg-violet-50 px-3 py-2 text-indigo-50',
        className,
      )}
    >
      <span className="font-heading text-sm">{children}</span>
      <span className="font-body rounded-full bg-white px-1 text-xs text-indigo-50">
        {count.toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}
      </span>
    </div>
  )
}

export default Pill
